import React from "react";

import BucketSection from "./BucketSection";
import { formatCompactCurrency } from "../../utils/formatters";

const HEADER_COLOR_CLASSES = {
  data_collection: "bg-gradient-to-r from-emerald-600 to-emerald-700",
  repapering: "bg-gradient-to-r from-amber-700 to-amber-800",
};

const PhaseColumn = ({
  phase,
  phaseNumber,
  projectId,
  navigate,
  actions,
  onActionComplete,
}) => {
  if (!phase) return null;
  const buckets = phase.buckets || [];
  const totalFlagged = phase.total_flagged || 0;
  if (totalFlagged === 0) return null;

  const openNigos =
    buckets.find((b) => b.key === "open_nigos")?.households?.length || 0;

  return (
    <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden flex flex-col">
      <div
        className={`px-5 py-4 text-white ${
          HEADER_COLOR_CLASSES[phase.key] || "bg-gray-700"
        }`}
      >
        <div className="text-[11px] font-semibold tracking-wider uppercase opacity-80">
          Phase {phaseNumber}
        </div>
        <div className="text-xl font-bold mt-0.5">{phase.label}</div>
        <div className="text-xs font-medium mt-2 opacity-90">
          <span className="font-bold">{totalFlagged}</span> Household
          {totalFlagged === 1 ? "" : "s"} flagged
          {openNigos > 0 && (
            <>
              <span className="opacity-60 mx-2">·</span>
              <span className="font-bold">{openNigos}</span> open NIGOs
            </>
          )}
          {phase.aum != null && (
            <>
              <span className="opacity-60 mx-2">·</span>
              <span className="font-bold">${formatCompactCurrency(phase.aum)}</span>{" "}
              AUM
            </>
          )}
        </div>
      </div>

      <div className="p-4 flex-1">
        {buckets.map((bucket) => (
          <BucketSection
            key={bucket.key}
            bucket={bucket}
            variant="section"
            projectId={projectId}
            navigate={navigate}
            actions={actions}
            onActionComplete={onActionComplete}
          />
        ))}
      </div>
    </div>
  );
};

export default PhaseColumn;
